import request from '@/router/axios';

const detail = params => request({
  // url: '/api/mcc-staff/vacationInfo/vacationDetail',
  url: '/api/mcc-base/baseVacationInfo/vacationDetail',
  method: 'get',
  params: {
    ...params,
  },
})

const vacationDetail = params => request({
  url: '/api/mcc-worker/vacation/detail',
  method: 'get',
  params: {
    ...params,
  },
})

// 假期管理
export const getVacationList = (current, size, params) => request({
  url: '/api/mcc-worker/vacation/page1',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
export const getVacationDetail = (params) => request({
  url: '/api/mcc-worker/vacation/detail1',
  method: 'get',
  params: {
    ...params,

  },
})
// 假期修改
export const vacationUpdate = params => request({
  url: '/api/mcc-worker/vacation/submit',
  method: 'post',
  data: {
    ...params,
  },
})

// 假期详情
export const vacationDetails = params => request({
  url: '/api/mcc-worker/vacation/detail1',
  method: 'get',
  params: {
    ...params,
  },
})

// 获取年假记录
export const getAnnualDays = params => request({
  url: '/api/mcc-worker/vacation/haveWorkerDays',
  method: 'get',
  params: {
    ...params,
  },
})

// 请假记录

export const leaverecordList = (current, size, params) => request({
  // url: '/api/mcc-worker/vacation/vacationPage',
  url: '/api/mcc-worker/vacation/vacationListAll',
  method: 'get',
  params: {
    current,
    size,
    ...params,
  },
})

// 上级领导看下级请假记录
// 审批页面请假记录
// /mcc-staff/leaverecord/deptManagerLeave
export const viewLeaveHistory = (current, size, params) => request({
  url: '/api/mcc-staff/leaverecord/page',
  method: 'get',
  params: {
    current,
    size,
    ...params,
  },
})

export const viewLeaveHistoryByWorker = (current, size, params) => request({
  url: '/api/mcc-worker/vacation/myLeaveByWorkerId',
  method: 'get',
  params: {
    current,
    size,
    ...params,
  },
})

export const exportExcel = params => request({
  url: '/api/mcc-worker/vacation/leaveRecordExcel',
  method: 'get',
  responseType: 'blob',
  params: {
    ...params,
  },
})
export default {
  detail,
  vacationDetail,
  getAnnualDays,
}
